import axios from "@/services/axios.config";
import {normalizeBudgetProjectMap} from "@/config/konekoAConfig";

export async function fetchMyMonthTargets(monthKey) {
  const res = await axios.get("api/koneko-a/me/month-targets/", {
    params: {month: monthKey},
    timeout: 10000,
  });
  return res.data || {};
}

export async function saveMyMonthTargets(monthKey, targets, replace = true) {
  const normalized = normalizeBudgetProjectMap(targets);
  const res = await axios.put(
    `api/koneko-a/me/month-targets/?month=${encodeURIComponent(monthKey)}${
      replace ? "&replace=true" : ""
    }`,
    {targets: normalized},
    {timeout: 10000}
  );
  return res.data || {};
}

export async function fetchRosterMonthTargets(monthKey) {
  const res = await axios.get("api/koneko-a/roster/month-targets/", {
    params: {month: monthKey},
    timeout: 25000,
  });
  return res.data || {};
}

/** Admin: save any roster member's personal month targets. */
export async function saveRosterMemberMonthTargets(
  monthKey,
  username,
  targets,
  replace = true
) {
  const normalized = normalizeBudgetProjectMap(targets);
  const res = await axios.put(
    `api/koneko-a/roster/month-targets/?month=${encodeURIComponent(
      monthKey
    )}&user=${encodeURIComponent(username)}${replace ? "&replace=true" : ""}`,
    {targets: normalized, username},
    {timeout: 15000}
  );
  return res.data || {};
}

export async function fetchOrgMonthBudgets(monthKey) {
  const res = await axios.get("api/koneko-a/org/month-budgets/", {
    params: {month: monthKey},
    timeout: 25000,
  });
  return res.data || {};
}

export async function fetchMyBudgetHistory(monthKey) {
  const res = await axios.get("api/koneko-a/me/budget-history/", {
    params: {month: monthKey},
    timeout: 10000,
  });
  return res.data || {};
}

/** Admin / view-as: audit log for a roster member's personal budget saves. */
export async function fetchRosterBudgetHistory(monthKey, username) {
  const res = await axios.get("api/koneko-a/roster/budget-history/", {
    params: {
      month: monthKey,
      user: username,
    },
    timeout: 10000,
  });
  return res.data || {};
}

export async function saveOrgMonthBudgets(monthKey, budgets, replace = true) {
  const normalized = normalizeBudgetProjectMap(budgets);
  const res = await axios.put(
    `api/koneko-a/org/month-budgets/?month=${encodeURIComponent(monthKey)}${
      replace ? "&replace=true" : ""
    }`,
    {budgets: normalized},
    {timeout: 10000}
  );
  return res.data || {};
}
